export const REQUEST_BALANCE_HOME = {
  IMPRESION: {
    elementName: "IMPRESION_PIDE_DATOS_Y_PAQUETES_HOME",
    elementLocation: "PIDE_DATOS_Y_PAQUETES_HOME",
  },
  CLIC_PRODUCTO: {
    elementName: "CLIC_",
    elementLocation: "PIDE_DATOS_Y_PAQUETES_HOME",
  },
  CLIC_VER_DETALLES: {
    elementName: "CLIC_VER_DETALLES",
    elementLocation: "PIDE_DATOS_Y_PAQUETES_DATOS_CONTACTO_",
  },
  CLIC_NOMBRE: {
    elementName: "CLIC_NOMBRE",
    elementLocation: "PIDE_DATOS_Y_PAQUETES_DATOS_CONTACTO_",
  },
  CLIC_PEDIR_PRODUCTO: {
    elementName: "CLIC_PEDIR_",
    elementLocation: "PIDE_DATOS_Y_PAQUETES_DATOS_CONTACTO_",
  },
  CLIC_TERMINOS_Y_CONDICIONES: {
    elementName: "CLIC_TERMINOS_Y_CONDICIONES",
    elementLocation: "PIDE_DATOS_Y_PAQUETES_HOME",
  },
  CLIC_AVISO_DE_PRIVACIDAD: {
    elementName: "CLIC_AVISO_DE_PRIVACIDAD",
    elementLocation: "PIDE_DATOS_Y_PAQUETES_HOME",
  },
  CLIC_CELULAR: {
    elementName: "CLIC_CELULAR",
    elementLocation: "PIDE_DATOS_Y_PAQUETES_DATOS_CONTACTO_",
  },
  WHATSAPP_BUTTON: {
    elementName: "CLIC_PEDIR_",
    elementLocation: "PIDE_DATOS_Y_PAQUETES_DATOS_CONTACTO_"
  }
};

export const DETAILS_POPUP = {
  IMPRESION: {
    elementName: "IMPRESION_MODAL_DETALLES_PRODUCTO",
    elementLocation: "PIDE_DATOS_Y_PAQUETES_DATOS_CONTACTO_",
  },
  CLOSE_BUTTON: {
    elementName: "CLIC_CERRAR_MODAL_DETALLES_PRODUCTO",
    elementLocation: "PIDE_DATOS_Y_PAQUETES_DATOS_CONTACTO_",
  },
};

export const PROCESSED_REQUEST = {
  IMPRESION: {
    elementName: "IMPRESION_RESULTADO",
    elementLocation: {
      PIDE_DATOS_Y_PAQUETES_RESULTADO_EXITOSO_:
        "PIDE_DATOS_Y_PAQUETES_RESULTADO_EXITOSO_",
      PIDE_DATOS_Y_PAQUETES_CELULAR_INCORRECTO_:
        "PIDE_DATOS_Y_PAQUETES_CELULAR_INCORRECTO_",
      PIDE_DATOS_Y_PAQUETES_ERROR_COMUNICACION_:
        "PIDE_DATOS_Y_PAQUETES_ERROR_COMUNICACION_",
      PIDE_DATOS_Y_PAQUETES_MAX_INTENTOS_:
        "PIDE_DATOS_Y_PAQUETES_MAX_INTENTOS_",
    },
  },
  BUTTON: {
    elementName: "CLIC_CONTINUAR",
    elementLocation: {
        PIDE_DATOS_Y_PAQUETES_RESULTADO_EXITOSO_:
          "PIDE_DATOS_Y_PAQUETES_RESULTADO_EXITOSO_",
        PIDE_DATOS_Y_PAQUETES_CELULAR_INCORRECTO_:
          "PIDE_DATOS_Y_PAQUETES_CELULAR_INCORRECTO_",
        PIDE_DATOS_Y_PAQUETES_ERROR_COMUNICACION_:
          "PIDE_DATOS_Y_PAQUETES_ERROR_COMUNICACION_",
        PIDE_DATOS_Y_PAQUETES_MAX_INTENTOS_:
          "PIDE_DATOS_Y_PAQUETES_MAX_INTENTOS_",
      },
  },
};
